import { useForm } from '@mantine/form';
import { Button, Group, TextInput } from '@mantine/core';
import React from 'react';

export interface MutatePaymentMethodFormValues {
  name: string;
}

interface MutatePaymentMethodFormProps {
  initialValues: MutatePaymentMethodFormValues;
  onSubmit: (formValues: MutatePaymentMethodFormValues) => void;
  onCancel?: () => void;
  isSubmitting?: boolean;
}

export default function MutatePaymentMethodForm({
  initialValues,
  onSubmit,
  onCancel,
  isSubmitting,
}: MutatePaymentMethodFormProps) {
  const form = useForm<MutatePaymentMethodFormValues>({
    mode: 'uncontrolled',
    initialValues: {
      name: initialValues.name,
    },
    validate: {
      name: (value) => {
        if (!value.trim()) return ' ';
      },
    },
  });

  const handleSubmit = form.onSubmit((values) => {
    onSubmit(values);
  });

  const handleCancel = () => {
    form.reset();
    onCancel?.();
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <TextInput
          label={'付款方式名稱'}
          placeholder={'請輸入付款方式名稱'}
          withAsterisk
          key={form.key('name')}
          {...form.getInputProps('name')}
          styles={{
            label: { marginBottom: 8 },
            input: {
              paddingLeft: 10,
              borderColor: form.errors.name
                ? 'var(--mantine-color-red-6)'
                : undefined,
            },
          }}
        />

        {/* 取消 與 新增 or 更新按鈕 */}
        <Group justify="flex-end" mt="md">
          <Button variant="outline" onClick={handleCancel}>
            取消
          </Button>
          <Button
            type="submit"
            loading={isSubmitting}
            loaderProps={{ type: 'oval', size: 'xs' }}
          >
            新增
          </Button>
        </Group>
      </form>
    </>
  );
}
